import React from "react";
import RutSerialNone from "./components/RutSerialNone";
import RunSerialQuestionNone from "./components/RunSerialQuestionNone";
import RutSerialMobileNone from "./components/RutSerialMobileNone";
import RutSerialForceMobileNone from "./components/RutSerialForceMobileNone";
import RunSerialSearch from "./components/RunSerialSearch";
import RunSerialForceMobileSearch from "./components/RunSerialForceMobileSearch";
import RunSerialMobileSearch from "./components/RunSerialMobileSearch";
import RunSerialQuestionsSearch from "./components/RunSerialQuestionsSearch";
import RunSerialSelect from "./components/RunSerialSelect";
import RunSerialForceMobileSelect from "./components/RunSerialForceMobileSelect";
import RunMobileSerialSelect from "./components/RunMobileSerialSelect";
import RunSerialQuestionsSelect from "./components/RunSerialQuestionsSelect";
import IdentityPassword from "./components/IdentityPassword";
import RutSerialMailPasswordNone from "./components/RutSerialMailPasswordNone";
import RutSerialMailPasswordSearch from "./components/RutSerialMailPasswordSearch";
import RutSerialMailPasswordSelect from "./components/RutSerialMailPasswordSelect";
import RutSerialPasswordNone from "./components/RunSerialPassword";
import RutSerialPasswordSelect from "./components/RunSerialPasswordSelect";
import RutSerialPasswordSearch from "./components/RunSerialPasswordSearch";



const ComoVotar = (props) => {
    const district_text = props.election.configuration.district_text? props.election.configuration.district_text:"distrito" ;
    const getInstructions = (identification_districts) => {
        switch (identification_districts) {
            case "identity+external_password-none":
                return (<IdentityPassword configuration={props.election.configuration}/>);
            case "run+serial-none":
                return (<RutSerialNone configuration={props.election.configuration}/>);
            case "run+serial_force_mobile-none":
                return (<RutSerialForceMobileNone configuration={props.election.configuration}/>);
            case "run+serial_mobile-none":
                return (<RutSerialMobileNone configuration={props.election.configuration}/>);
            case "run+serial_questions-none":
                return (<RunSerialQuestionNone configuration={props.election.configuration}/>);
            case "run+serial-search":
                return (<RunSerialSearch  configuration={props.election.configuration}/>);
            case "run+serial_force_mobile-search":
                return (<RunSerialForceMobileSearch  configuration={props.election.configuration}/>);
            case "run+serial_mobile-search":
                return (<RunSerialMobileSearch configuration={props.election.configuration}/>);
            case "run+serial_questions-search":
                return (<RunSerialQuestionsSearch  configuration={props.election.configuration}/>);
            case "run+serial-select":
                return (<RunSerialSelect district_text={district_text} configuration={props.election.configuration}/>);
            case "run+serial_force_mobile-select":
                return (<RunSerialForceMobileSelect district_text={district_text} configuration={props.election.configuration}/>);
            case "run+serial_mobile-select":
                return (<RunMobileSerialSelect district_text={district_text} configuration={props.election.configuration}/>);
            case "run+serial_questions-select":
                return (<RunSerialQuestionsSelect district_text={district_text} configuration={props.election.configuration}/>);
            case "run+external_password-none":
                return (<RutSerialMailPasswordNone configuration={props.election.configuration}/>);
            case "run+external_password-select":
                return (<RutSerialMailPasswordSelect district_text={district_text} configuration={props.election.configuration}/>);
            case "run+external_password-search":
                return (<RutSerialMailPasswordSearch configuration={props.election.configuration}/>);
            case "run+serial_password-none":
                return (<RutSerialPasswordNone configuration={props.election.configuration}/>);
                case "run+serial_password-search":
                    return (<RutSerialPasswordSearch configuration={props.election.configuration}/>);
            case "run+serial_password-select":
                return (<RutSerialPasswordSelect district_text={district_text} configuration={props.election.configuration}/>);
            default:
                return (<RutSerialNone configuration={props.election.configuration}/>);

        }

    }

        return (
            <div className="row justify-content-center EvColorBlue mt-4">
                <div className="col-12 text-center text-white">
                    <div className="row">
                        <div className="col-12 text-center ">
                            <h1 className=" font-weight-bold mt-4 mb-4">¿Cómo se vota?</h1>
                        </div>
                    </div>
                    {getInstructions(props.election.configuration.identification_field.concat("-" + props.election.configuration.districts))}
                </div>
            </div>
        );
    
}

export default ComoVotar;